import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component, useEffect } from 'react';
import { css } from 'emotion';
import { Toast } from 'antd-mobile-v2';
import { useDrag, useDrop, useDragLayer } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import sanitize from 'sanitize-html';
import FormItem from '../FormItem';
import IconFont from '@/components/common/IconFont';
import Sort from '../../common/Question/Sort';
var SortMobild = /*#__PURE__*/function (_Component) {
  _inherits(SortMobild, _Component);
  function SortMobild() {
    _classCallCheck(this, SortMobild);
    return _possibleConstructorReturn(this, _getPrototypeOf(SortMobild).apply(this, arguments));
  }
  _createClass(SortMobild, [{
    key: "onErrorClick",
    value: function onErrorClick(error) {
      Toast.info(error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      var _question$custom$sort = question.custom.sortType,
        sortType = _question$custom$sort === void 0 ? 'drag' : _question$custom$sort;
      return React.createElement(Sort, this.props, function (_ref) {
        var options = _ref.options,
          error = _ref.error,
          onChange = _ref.onChange,
          formAnswer = _ref.formAnswer,
          handleDrop = _ref.handleDrop,
          handleDragStart = _ref.handleDragStart,
          clickedOptions = _ref.clickedOptions;
        return React.createElement(FormItem, {
          error: error.selected || error.text,
          label: label,
          question: question
        }, React.createElement("div", {
          id: _this.props.question.id,
          className: "flex"
        }, React.createElement("div", {
          className: "flex1"
        }, React.createElement(CustomDragLayer, null), (options || []).map(function (option, index) {
          return React.createElement(OptionItem, {
            key: option.id,
            index: index,
            isFirst: index === 0,
            isLast: index === options.length - 1,
            question: question,
            option: option,
            onChange: onChange,
            formAnswer: formAnswer,
            handleDrop: handleDrop,
            handleDragStart: handleDragStart,
            sortType: sortType,
            clickedOptions: clickedOptions
          });
        }))));
      });
    }
  }]);
  return SortMobild;
}(Component);
export { SortMobild as default };
export function OptionItem(_ref2) {
  var question = _ref2.question,
    option = _ref2.option,
    handleDrop = _ref2.handleDrop,
    sortType = _ref2.sortType,
    onChange = _ref2.onChange,
    handleDragStart = _ref2.handleDragStart,
    index = _ref2.index,
    isLast = _ref2.isLast,
    isFirst = _ref2.isFirst,
    clickedOptions = _ref2.clickedOptions;
  var optionLen = question.custom.options.length;
  var _useDrag = useDrag({
      item: {
        type: 'OPTION',
        option: option,
        index: index
      },
      canDrag: function canDrag() {
        return sortType === 'drag';
      },
      begin: function begin() {
        handleDragStart(option.id);
      },
      end: function end() {
        handleDragStart('');
      },
      collect: function collect(monitor) {
        return {
          isDragging: !!monitor.isDragging()
        };
      }
    }),
    _useDrag2 = _slicedToArray(_useDrag, 3),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1],
    preview = _useDrag2[2];
  useEffect(function () {
    preview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, []);
  var _useDrop = useDrop({
      accept: 'OPTION',
      hover: function hover(item) {
        var dragIndex = item.index;
        var hoverIndex = index;
        if (dragIndex === undefined) {
          return;
        }
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return;
        }
        setTimeout(function () {
          handleDrop(option.id);
        }, 100);
        item.index = hoverIndex;
      },
      drop: function drop() {},
      collect: function collect(monitor) {
        return {
          isOver: !!monitor.isOver()
        };
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    isOver = _useDrop2[0].isOver,
    drop = _useDrop2[1];
  return React.createElement("div", {
    ref: drop,
    key: option.id,
    style: {
      userSelect: 'none'
    },
    onClick: function onClick() {
      if (sortType !== 'click') return;
      onChange.click(option.id);
    }
  }, React.createElement("div", {
    className: "flex"
  }, sortType === 'drag' && React.createElement("div", {
    className: sortIndex(index, optionLen)
  }, " ", index + 1, " "), React.createElement("div", {
    className: dragItemBox,
    ref: drag,
    key: option.id,
    id: option.id,
    style: {
      boxShadow: isOver && '0 6px 16px 0 rgba(40, 52, 70, 0.08) inset',
      marginBottom: isLast ? 0 : 8,
      opacity: isDragging ? 0 : 1,
      height: isDragging ? 0 : '',
      paddingTop: isFirst ? 0 : undefined,
      paddingBottom: isLast ? 0 : undefined
    }
  }, React.createElement(OptionTextRender, {
    index: index,
    option: option,
    isDragging: isDragging,
    sortType: sortType,
    clickedOptions: clickedOptions
  }))));
}
function OptionTextRender(props) {
  var option = props.option,
    isDragging = props.isDragging,
    sortType = props.sortType,
    index = props.index,
    clickedOptions = props.clickedOptions;
  return React.createElement("div", {
    key: option.id,
    className: "flex alignCenter",
    style: {
      border: isDragging ? '0px solid var(--ant-border)' : '1px solid var(--ant-border)',
      borderRadius: 4,
      padding: '13px 16px',
      height: isDragging ? 48 : 'auto'
    }
  }, sortType === 'drag' && React.createElement(IconFont, {
    type: "icon-menu",
    color: "var(--primary-color)"
  }), sortType === 'click' && React.createElement("div", {
    className: "indexBox"
  }, clickedOptions.includes(option.id) && React.createElement("span", {
    className: "blueColor"
  }, index + 1)), React.createElement("div", {
    className: "flex1 marginLeft10 marginRight10 no-touch no-event"
  }, React.createElement("div", {
    className: "optionText",
    dangerouslySetInnerHTML: {
      __html: sanitize(window.showMultiLang ? option === null || option === void 0 ? void 0 : option["".concat(window.language, "Text")] : option.text)
    }
  }), option.description && React.createElement("div", {
    style: {
      fontSize: 12,
      color: 'var(--text-color-thirdly)',
      lineHeight: 1.5,
      fontWeight: 400
    }
  }, option.description), option.img ? React.createElement("img", {
    src: option.img,
    alt: "",
    style: {
      zoom: option.scale || 1,
      marginTop: 10,
      marginBottom: 10
    },
    loading: "lazy"
  }) : ''));
}
var layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};
export var CustomDragLayer = function CustomDragLayer() {
  var _useDragLayer = useDragLayer(function (monitor) {
      return {
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        isDragging: monitor.isDragging(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset()
      };
    }),
    itemType = _useDragLayer.itemType,
    isDragging = _useDragLayer.isDragging,
    item = _useDragLayer.item,
    initialOffset = _useDragLayer.initialOffset,
    currentOffset = _useDragLayer.currentOffset;
  function renderItem() {
    if (itemType === 'OPTION') {
      return React.createElement(OptionTextRender, {
        option: item.option,
        isDragging: isDragging
      });
    }
    return null;
  }
  if (!isDragging) {
    return null;
  }
  return React.createElement("div", {
    style: _objectSpread({}, layerStyles)
  }, React.createElement("div", {
    style: getItemStyles(initialOffset, currentOffset)
  }, renderItem()));
};
function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }
  var x = currentOffset.x,
    y = currentOffset.y;
  var transform = "translate(".concat(x, "px, ").concat(y, "px)");
  return {
    border: '1px solid var(--ant-border)',
    borderRadius: 4,
    transform: transform,
    WebkitTransform: transform,
    background: 'var(--ant-bg)',
    width: 'calc(100% - 50px)',
    color: 'var(--primary-color)',
    maxWidth: window.innerWidth > 1440 ? 720 : 630,
    boxShadow: '0 6px 16px 0 var(--ant-border)'
  };
}
var _ref3 = "border-top:";
var _ref4 = ";border-bottom:";
var _ref5 = ";border-radius:";
var _ref6 = ";border-radius:";
var _ref7 = ";user-select:none;pointer-events:none;background:var(--ant-bg);color:var(--text-color);border-left:1px solid var(--ant-border);border-right:1px solid var(--ant-border);width:29px;font-size:16px;margin-right:16px;display:flex;flex:none;flex-direction:column;align-items:center;justify-content:space-around;";
var sortIndex = function sortIndex(index, optionLen) {
  return /*#__PURE__*/css(_ref3, index ? 0 : '1px solid var(--ant-border)', _ref4, index === optionLen - 1 ? '1px solid var(--ant-border)' : 0, _ref5, index ? 0 : '2px 2px 0 0 !important', _ref6, index === optionLen - 1 ? '0 0 2px 2px !important' : 0, _ref7);
};
var dragItemBox = /*#__PURE__*/css("flex:1;max-width:", window.innerWidth > 1440 ? 720 : 630, "px;cursor:pointer;padding:0;.ant-checkbox{display:flex;align-items:flex-start;}.ant-input{border-color:var(--ant-border);}.option-error .ant-input{border-color:var(--text-red);}.other{width:auto;}.ant-checkbox + span{display:inline-block;margin-top:-3px;}.optionText{font-size:1rem;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color);}.indexBox{height:18px;width:18px;border-radius:2px;display:flex;align-items:center;justify-content:center;border:1px solid var(--ant-border);}");